import { render, staticRenderFns } from "./AppAnomalias.vue?vue&type=template&id=c0a1f47c&scoped=true&"
import script from "./AppAnomalias.vue?vue&type=script&lang=js&"
export * from "./AppAnomalias.vue?vue&type=script&lang=js&"
import style0 from "./AppAnomalias.vue?vue&type=style&index=0&id=c0a1f47c&scoped=true&lang=scss&"
import style1 from "./AppAnomalias.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a1f47c",
  null
  
)

export default component.exports